<template>
      <div>
           <div class="tableTop" @click="getStatus">
                                       <label class="tableTopTitle">
                                     <span v-if="type==1">生存</span>   <span v-else>身故</span>   受益人信息</label>
                                       <label  v-show="beneficiaryShow"  class="tableTopRight">收起 <img style="width:16px" src="../../../../static/image/policy/triangle.png"> </label>
                                       <label  v-show="!beneficiaryShow"  class="tableTopRight">展开 <img style="width:16px" src="../../../../static/image/policy/triangle.png"> </label>
                                    </div>
                                   <div v-show="beneficiaryShow">
                                       <template>
                                            <el-table
                                               
                                                :data="list"
                                                style="width: 100%">
                                                <el-table-column
                                                align="center"
                                                label="客户号"
                                                >
                                                <template slot-scope="scope">
                                                    <span style="margin-left: 10px">{{scope.row.clntnum}}</span>
                                                </template>
                                                </el-table-column>
                                                <el-table-column
                                                align="center"
                                                label="投保人"
                                               >
                                                <template slot-scope="scope">
                                                        <span >{{scope.row.fullName}}</span>
                                                </template>
                                                </el-table-column>
                                                <el-table-column
                                                    align="center"
                                                    label="称谓">
                                                    <template slot-scope="scope">
                                                        <span >{{scope.row.salut}}</span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                    align="center"
                                                    label="出生日期">
                                                    <template slot-scope="scope">
                                                        <span >{{changeTime(scope.row.cltdob)}}</span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                    align="center"
                                                    label="证件号"
                                                     width="240">
                                                    <template slot-scope="scope">
                                                        <span>{{scope.row.secuityNo}}</span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                    align="center"
                                                    label="联系方式1"
                                                    width="150">
                                                    <template slot-scope="scope">
                                                        <span>{{scope.row.cltPhone01}}</span>
                                                    </template>
                                                </el-table-column>
                                                 <el-table-column
                                                    align="center"
                                                    label="联系方式2"
                                                    width="150">
                                                    <template slot-scope="scope">
                                                        <span>{{scope.row.cltPhone02}}</span>
                                                    </template>
                                                </el-table-column>
                                                 <el-table-column
                                                    align="center"
                                                    label="联系地址"
                                                    width="340"
                                                    >
                                                    <template slot-scope="scope">
                                                        <span>{{scope.row.fullAddress}}</span>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                            </template>
                                   </div>
  </div>
</template>

<script>
import api from '../../../modules/api'
import urls from '../../../modules/url'
import Vue from 'vue';

  export default {
    name:'Beneficiary',
     components: {
     },
    data(){
      return{
       list:[],
          UserDTO:{},
          beneficiaryShow:false
      }
    },
    props:{
       type:{
       type: Number
     }, 
      clntnum:{
       type: String
     },
     cowncoy:{
       type: String
     }
    },
    mounted(){
       
    },
    created() {
      this.getBeneficiary()
    },
    methods:{
        loadings () {
      this.$toast.loading({
        mask: true,
        message: '加载中...',
        duration: 0
      })
    },
    closeLoadings () {
      this.$toast.clear()
    },
        findIt () {
      this.routerFlag = '0'
      console.log(this.$route,'123')
      let that = this
      console.log(that.UserDTO)
      this.UserDTO.COWNNUM = this.list.clntnum
      if(this.active == '2'){
        this.UserDTO.CLNTCOY = this.list.clntcoy
      }else{
        this.UserDTO.CLNTCOY = this.list.clntcoy
      }
      this.UserDTO.FLAG = 1
      this.$router.push({path: '/getPolicyList', query: {routerDTO:JSON.stringify(this.routerDTO), UserDTO: JSON.stringify(this.UserDTO),active:2,Persion:JSON.stringify(this.Persion),origin:this.origin,incomeTop: this.top}})
    },
      changeTime (data) {
      let time = data.slice(0, 4) + '-' + data.slice(4, 6) + '-' + data.slice(6, 8)
      if(!data){
        time ='';
      }
      if(data == '0'){
        time = data;
      }
      return time
    },
    getStatus(){
      
       
             this.beneficiaryShow=!this.beneficiaryShow
        
    },
          getBeneficiary () {
  
     let options = {
        // 客户区号
        CLNTCOY: this.cowncoy,
        CLNTNUM: this.clntnum, // this.$route.query.chdrnumId,
        type: '2'
      }
      let msg = {queryTerms: JSON.stringify(options)}
      api.getPersionInfo(msg, (res) => {
      
         
        if (res.data.data) {
          this.list.push(res.data.data)
      
          this.list[0].cltdob = that.clntnum.cltdob.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3')
        }
       
      })
    
    },
    }
  }
</script>

<style scoped>
  .tableTopTitle{
    padding-left: 20px;
    font-size: 15px;
    line-height: 40px;
    color: #111111;
    font-weight: 500;
}
.tableTop{
    width: calc(100% + 40px);
    height: 40px;
    background: #F7F7F7;
    margin-top: -20px;
    margin-left: -20px;
    margin-right: -20px;
    cursor: pointer;
}
    .tableTopRight{
     padding-right: 40px;
    float: right;
    font-size: 16px;
    line-height: 40px;
    }

</style>



// WEBPACK FOOTER //
// src/pages/policy/components/Beneficiary.vue